import React from 'react';
import { css } from 'emotion';
import { text, border, neutral, news } from '@guardian/src-foundations/palette';
import { headline, textSans } from '@guardian/src-foundations/typography';
import { space } from '@guardian/src-foundations';
import { until } from '@guardian/src-foundations/mq';
import { pillarPalette } from '@frontend/lib/pillars';
import { createAuthenticationEventParams } from "@root/src/lib/identity-component-event";
const containerStyles = css `
    padding-top: ${space[1]}px;
    padding-bottom: ${space[1]}px;
`;
const imageStyles = css `
    border-radius: 70px;
    width: 60px;
    height: 60px;
    ${until.desktop} {
        width: 36px;
        height: 36px;
    }
`;
const imageWrapper = css `
    padding-bottom: ${space[1]}px;
    padding-right: ${space[2]}px;
`;
const headingStyles = css `
    ${headline.xxsmall({ fontWeight: 'bold' })};
    padding-bottom: ${space[1]}px;
`;
const textStyles = css `
    ${textSans.small()}
    ${until.desktop} {
        ${textSans.xsmall()}
    }
    color: ${text.supporting};
    padding-bottom: ${space[1]}px;
`;
const headlineStyles = css `
    ${headline.xxxsmall()}
    color: ${text.supporting};
    padding-bottom: ${space[1]}px;
`;
const usernameStyles = css `
    font-weight: 700;
    color: ${text.primary};
`;
const linkStyles = (pillar) => css `
    color: ${pillarPalette[pillar].dark};
    text-decoration: none;
    border-bottom: 1px solid ${border.secondary};
    transition: border-color 0.15s ease-out;
    :hover {
        border-color: ${news[300]};
    }
`;
const rowUntilDesktop = css `
    display: flex;
    flex-direction: column;
    ${until.desktop} {
        flex-direction: row;
    }
`;
export const SignedInAs = ({ commentCount, pillar, enableDiscussionSwitch, user, isClosedForComments, }) => {
    const isBanned = user &&
        user.privateFields &&
        user.privateFields.canPostComment === false;
    return (React.createElement("div", { className: containerStyles },
        React.createElement("h2", { className: headingStyles },
            "comments",
            ' ',
            React.createElement("span", { className: css `
                        color: ${neutral[60]};
                    ` },
                "(",
                commentCount,
                ")")),
        enableDiscussionSwitch && isBanned && (React.createElement("span", { className: headlineStyles },
            "Commenting has been disabled for this account (",
            React.createElement("a", { href: "https://www.theguardian.com/community-faqs#321a", className: linkStyles(pillar) }, "why?"),
            ' ',
            ")")),
        user && enableDiscussionSwitch === false && (React.createElement("span", { className: headlineStyles }, "Commenting has been disabled at this time")),
        enableDiscussionSwitch &&
            user &&
            !isBanned &&
            !isClosedForComments && (React.createElement("div", { className: rowUntilDesktop },
            React.createElement("div", { className: imageWrapper },
                React.createElement("img", { src: user.secureAvatarUrl ||
                        'https://avatar.guim.co.uk/no-user-image.gif', alt: user.displayName || 'Guardian User', className: imageStyles })),
            React.createElement("div", { className: textStyles },
                "Signed in as",
                React.createElement("div", { className: usernameStyles }, user.displayName || 'Guardian User')))),
        !user && (React.createElement("span", { className: headlineStyles },
            React.createElement("a", { href: `https://profile.theguardian.com/signin?INTCMP=DOTCOM_COMMENTS_SIGNIN&${createAuthenticationEventParams('signin_to_comment')}`, className: linkStyles(pillar) }, "Sign in"),
            ' ',
            "or",
            ' ',
            React.createElement("a", { href: `https://profile.theguardian.com/register?INTCMP=DOTCOM_COMMENTS_REG&${createAuthenticationEventParams('register_to_comment')}`, className: linkStyles(pillar) }, "create your Guardian account"),
            ' ',
            "to join the discussion.")),
        enableDiscussionSwitch && user && isClosedForComments && (React.createElement("span", { className: headlineStyles }, "This discussion is closed for comments"))));
};
